export const clearStoredSession = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('username');
    localStorage.removeItem('roles');
};

export const storeSession = (accessToken: string, refreshToken: string | null, username: string, roles?: string[]) => {
    localStorage.setItem('token', accessToken);
    localStorage.setItem('username', username);

    if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken);
    } else {
        localStorage.removeItem('refreshToken');
        console.warn('Login succeeded without a Refresh-Token header.');
    }

    if (roles && roles.length > 0) {
        localStorage.setItem('roles', JSON.stringify(roles));
    }
};

export const storeRoles = (roles: string[]) => {
    if (roles && roles.length > 0) {
        localStorage.setItem('roles', JSON.stringify(roles));
    } else {
        localStorage.removeItem('roles');
    }
};

export const getStoredRoles = (): string[] => {
    try {
        const stored = localStorage.getItem('roles');
        if (stored) {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) {
                return parsed;
            }
        }
    } catch (e) {
        console.error('Error reading stored roles', e);
    }
    return [];
};

export const getJwtClaims = (token: string | null): Record<string, unknown> => {
    if (!token) return {};

    try {
        const payload = token.replace(/^Bearer\s+/i, '').split('.')[1];
        if (!payload) return {};

        const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
        const paddedPayload = normalizedPayload.padEnd(Math.ceil(normalizedPayload.length / 4) * 4, '=');
        return JSON.parse(atob(paddedPayload));
    } catch (e) {
        return {};
    }
};

export const isImpersonatedToken = (token: string | null) => {
    const claim = getJwtClaims(token).impersonated;
    return claim === true || claim === 'true';
};
